export class GetContactsDto {
  public ListID: number;
  public ContactIDs: Array<number>;

  constructor(init: any) {
    this.ListID = init.ListID;
    this.ContactIDs = init.ContactIDs;
  }
}
